var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form__input__wrapper"},[_c('div',{class:[
      'form__input__text',
      _vm.state !== null ? ("form__input__text--" + _vm.state) : false ],attrs:{"data-sending":_vm.params.sending,"data-sent":_vm.params.sent}},[_vm._v("\n    "+_vm._s(_vm.params.text)+"\n  ")]),_c('input',{attrs:{"type":"submit"}}),_c('div',{ref:"line",staticClass:"form__input__line"})])}
var staticRenderFns = []

export { render, staticRenderFns }